import { FunctionComponent } from 'react';
import { ViewMap } from '@/types';
import { SvgLine } from '@/utils/math/types';

interface Props {
  viewMap: ViewMap;
  lines: SvgLine[];
}

export const SnapLines: FunctionComponent<Props> = ({ lines }) => (
  <g>
    {lines.map((l, i) => (
      <line {...l} key={i} stroke="#3284cb" strokeWidth="1" vectorEffect="non-scaling-stroke" />
    ))}
  </g>
);
